import { render, staticRenderFns } from "./selectTeachResourse.vue?vue&type=template&id=6c0a4638&scoped=true"
import script from "./selectTeachResourse.vue?vue&type=script&lang=js"
export * from "./selectTeachResourse.vue?vue&type=script&lang=js"
import style0 from "./selectTeachResourse.vue?vue&type=style&index=0&id=6c0a4638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a4638",
  null
  
)

export default component.exports